module.exports = __webpack_public_path__ + "b287fe391ad2025ff2d2c6ed215c7057.png";